import { useIntl } from 'react-intl';
import { Range } from 'sonata-react-components';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

type Props = {
  budget: number;
  currency: BaseCurrencyInterface;
  onChange: (val: number) => void;
};

function GoalPacingDistribution({ budget, currency, onChange }: Props) {
  const { formatMessage } = useIntl();

  const totalBudgetLabel = `${formatMessage({
    defaultMessage: 'Total Budget',
    id: 'targeting.mediaQualityAssuranceSystem.range.total'
  })}: ${currency?.currencyPosition === 'left' ? currency.currencySymbol : ''}${budget}${
    currency?.currencyPosition === 'right' ? currency.currencySymbol : ''
  }`;

  const handleRangeChange = (val: number) => {
    const budgetPercentage = (val * 100) / budget;
    const distribution = 100 - budgetPercentage;
    onChange(distribution);
  };

  return (
    <Range
      id="viewabilityTargetingSegmentRange"
      max={budget}
      min={0}
      onChange={val => handleRangeChange(val as number)}
      type="slider"
      value={budget}
    >
      <Range.Title>
        <Range.Title.Left>
          {formatMessage({
            defaultMessage: 'PRE BID ON',
            id: 'targeting.mediaQualityAssuranceSystem.range.left'
          })}
        </Range.Title.Left>
        <Range.Title.Right>
          {formatMessage({
            defaultMessage: 'PRE BID OFF',
            id: 'targeting.mediaQualityAssuranceSystem.range.right'
          })}
        </Range.Title.Right>
      </Range.Title>
      <Range.SliderInput />
      <Range.Info>
        <Range.Info.Center>{totalBudgetLabel}</Range.Info.Center>
      </Range.Info>
    </Range>
  );
}

export default GoalPacingDistribution;
